import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';

import { InputPassword, InputProps, ValidationMessage } from '@xsolla/ui-core';

import { FlexParentBlock, SpaceBetweenBlock } from '../../../styled';
import { ExtraFieldLink, FieldInputTitle, FullWideContentBlock } from '../FieldInput/style';

type Props = InputProps & {
  label?: ReactNode;
  extraRight?: ReactNode;
  additional?: ReactNode;
  extraLink?: {
    title: ReactNode;
    to: string;
  };
  name: string;
};

const FieldInput = ({
  label,
  extraRight,
  errorMessage,
  name,
  additional,
  extraLink,
  ...props
}: Props): JSX.Element => {
  return (
    <>
      <SpaceBetweenBlock>
        <FieldInputTitle>{label}</FieldInputTitle>
        {additional && <div>{additional}</div>}
      </SpaceBetweenBlock>
      <FlexParentBlock>
        <FullWideContentBlock>
          <Field name={name}>
            {({ input, meta }) => (
              <>
                <InputPassword
                  name={input.name}
                  value={input.value}
                  spellCheck={false}
                  onChange={(e) => {
                    input.onChange(e.target.value || null);
                  }}
                  {...props}
                />

                {extraLink && (
                  <ExtraFieldLink href={extraLink.to} target="_blank">
                    {extraLink.title}
                  </ExtraFieldLink>
                )}
                <ValidationMessage>
                  {(meta.modified || meta.submitFailed) && errorMessage}
                </ValidationMessage>
              </>
            )}
          </Field>
        </FullWideContentBlock>
        {extraRight}
      </FlexParentBlock>
    </>
  );
};

export default FieldInput;
